import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLightContext, setIsLightContext] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
      
      const lightSections = document.querySelectorAll('.light-section');
      let overLight = false;
      const headerBottom = 100;
      
      lightSections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= headerBottom && rect.bottom >= 20) {
          overLight = true;
        }
      });
      
      setIsLightContext(overLight);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Services', id: 'services' },
    { name: 'Why LAJ', id: 'why-us' },
    { name: 'Our Team', id: 'team' },
    { name: 'How It Works', id: 'process' },
  ];

  const navContainerBg = (isScrolled || isMobileMenuOpen) 
    ? 'rounded-2xl lg:rounded-full bg-gray-950/95 backdrop-blur-xl border-gray-800/50 shadow-xl' 
    : 'rounded-2xl lg:rounded-full bg-transparent border-transparent';

  const lightModeClass = (isScrolled && isLightContext) && !isMobileMenuOpen 
    ? '!bg-white/95 !border-gray-200/50 !shadow-sm' 
    : '';

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-500 ${isScrolled || isMobileMenuOpen ? 'pt-2 md:pt-4 pb-2' : 'pt-4 md:pt-8 pb-4'}`}>
      <div className="container-custom">
        <div className={`flex flex-col lg:flex-row items-center justify-between px-4 md:px-6 py-3 md:py-4 transition-all duration-500 border mx-auto ${navContainerBg} ${lightModeClass}`}>
          
          <div className="flex w-full lg:w-1/4 justify-between items-center lg:justify-start">
            <Link to="/" className="flex items-center z-50 shrink-0" onClick={() => setIsMobileMenuOpen(false)}>
              <img 
                src="https://media-manager-c.questera.ai/greta-media/1593c15ad88356866a2eabcebc8aef2c67d9fc5afee8d56439ced245a0c6c3417efffbd95aedd1b6f68107af9f17a1fd/images/aW1hZ2UvcG5n/7cf330b2fb2aaf6b54c2cba38f69981f.png" 
                alt="LAJ Digital Logo" 
                className={`h-7 md:h-9 w-auto object-contain transition-all duration-300 hover:opacity-80 ${(isScrolled && isLightContext) && !isMobileMenuOpen ? 'brightness-0' : ''}`}
              />
            </Link>
            
            <button 
              className={`lg:hidden text-3xl transition-colors ${(isScrolled && isLightContext) && !isMobileMenuOpen ? 'text-gray-900' : 'text-gray-300 hover:text-white'}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <SafeIcon icon={isMobileMenuOpen ? "FiX" : "FiMenu"} />
            </button>
          </div>

          <nav className={`${isMobileMenuOpen ? 'flex' : 'hidden'} lg:flex flex-col lg:flex-row w-full lg:w-1/2 justify-center items-center gap-y-6 gap-x-4 md:gap-x-6 mt-8 mb-4 lg:my-0`}>
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to="/"
                state={{ scrollTo: link.id }}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-base font-bold transition-colors uppercase tracking-widest whitespace-nowrap ${
                  (isScrolled && isLightContext) && !isMobileMenuOpen
                    ? 'text-gray-600 hover:text-cyan-600'
                    : 'text-gray-300 hover:text-cyan-400'
                }`}
              >
                {link.name}
              </Link>
            ))}

            <Link 
              to="/"
              state={{ scrollTo: 'contact' }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="lg:hidden mt-2 px-8 py-3 rounded-full border text-base font-bold backdrop-blur-md transition-all duration-300 border-gray-700 text-white bg-white/[0.05] hover:bg-purple-500/10 hover:border-purple-400"
            >
              Get Started
            </Link>
          </nav>

          <div className="hidden lg:flex w-full lg:w-1/4 justify-end">
            <Link 
              to="/"
              state={{ scrollTo: 'contact' }}
              className={`px-6 py-2.5 rounded-full border text-base font-bold backdrop-blur-md transition-all duration-300 ${
                (isScrolled && isLightContext)
                  ? 'border-gray-300 text-gray-900 bg-black/[0.05] hover:bg-cyan-500/10 hover:border-cyan-600 hover:text-cyan-700'
                  : 'border-gray-700 text-white bg-white/[0.05] hover:bg-purple-500/10 hover:border-purple-400 hover:text-purple-300'
              }`}
            >
              Get Started
            </Link>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;